import { createField } from '~/utils/manifest-utils';

export const CLEENG_MEDIASTORE = 'mediastore';
export const CLEENG_LOW_CODE = 'low_code';

export const getCleengImplementationTypeOptions = () => {
  return [
    createField({
      key: 'cleeng_implementation_type',
      label: 'Cleeng Implementation Type',
      type: 'select',
      options: [
        {
          text: 'Mediastore SDK Implementation',
          value: CLEENG_MEDIASTORE,
        },
        {
          text: 'Cleeng Low Code (Hosted Widgets)',
          value: CLEENG_LOW_CODE,
        },
      ],
      initial_value: CLEENG_MEDIASTORE,
      conditional_fields: [
        {
          key: 'select_payment_provider',
          condition_value: 'Cleeng',
        },
      ],
    }),
  ];
};
